<!-- @format -->

<ng-container *transloco="let t">
  @if (data$ | async; as data) {
    @if (isApplicationApproved(data.newestWorkflow)) {
      <fudis-notification [variant]="'success'">
        <fudis-body-text>
          {{
            t("PLAN.GRADUATION_APPROVED_ALERT", {
              moduleName: module.name | localizedString,
              graduationDate: data.newestWorkflow.decision.approvalDate | localDateFormat,
            })
          }}
          <a
            fudisLink
            [href]="'#'"
            [title]="t('PLAN.SHOW_DEGREE_PROGRAMME_ATTAINMENT_MESSAGE')"
            [size]="'md'"
            (click)="navigateToWorkflow(data.newestWorkflow.id)"></a>
        </fudis-body-text>
      </fudis-notification>
    } @else if (canGraduateFromSelectedModule(data)) {
      <fudis-notification [variant]="'warning'">
        <fudis-body-text>
          {{ t("PLAN.CAN_GRADUATE_TEXT", { module: module.name | localizedString }) }}
          <a fudisLink [href]="'#'" [title]="t('PLAN.APPLY_FOR_GRADUATION')" [size]="'md'" (click)="openGraduationDialog()"></a>
        </fudis-body-text>
      </fudis-notification>
    } @else if (graduationRequestedForSelectedModule(data)) {
      <fudis-notification [variant]="'info'">
        <fudis-body-text>
          {{ t("PLAN.GRADUATION_REQUESTED_ALERT", { module: module.name | localizedString }) }}
          <a
            fudisLink
            [href]="'#'"
            [title]="t('PLAN.SHOW_DEGREE_PROGRAMME_ATTAINMENT_MESSAGE')"
            [size]="'md'"
            (click)="navigateToWorkflow(data.newestWorkflow.id)"></a>
        </fudis-body-text>
      </fudis-notification>
    }
  }
</ng-container>
